// extracted by mini-css-extract-plugin
export default {"container":"datenschutz_container__7VmXH","table":"datenschutz_table__Edc6A","listDiv":"datenschutz_listDiv__pI3y9","tile":"datenschutz_tile__ZcS2p"};